const signKey = "c75k3d2e83d01f49ayeb02a5db2ebf4a";

// 排序的函数
function objKeySort(obj) {
  let newKey = Object.keys(obj).sort();
  // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  let newObj = {};// 创建一个新的对象，用于存放排好序的键值对
  for (let i = 0; i < newKey.length; i++) {// 遍历newkey数组
    newObj[newKey[i]] = obj[newKey[i]];// 向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj;// 返回排好序的新对象
}
// 参数拼接
function parseParam (param, key, encode) {
  if(param == null){
    return '';
  }
  let paramStr = '';
  let t = typeof (param);
  if (t == 'string' || t == 'number' || t == 'boolean') {
    paramStr += key + '=' + param;
  } else {
    for (let i in param) {
      let k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
      paramStr += (paramStr == '' ? '' : '&') + parseParam(param[i], k, encode);
    }
  }
  return paramStr;
}

// 加密参数
export default function sign(params) {
  // 删除签名属性
  this.$delete(params,'sign')
  // 生成时间戳
  params.timestamp = Date.now();
  // 拼接参数
  let paramStr = parseParam(objKeySort(params)) + "&key=" + signKey
  // 获取签名
  params.sign = this.$md5(paramStr).toUpperCase();
  return params;
}



// WEBPACK FOOTER //
// ./src/utill/signUtils.js